import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type FeaturesService from '@square/ember-features/services/features';

export default class Application extends Controller {
  queryParams = ['fetchScenario'];

  @service declare features: FeaturesService;

  get enableMonochrome() {
    return this.features.isEnabled('uisystems-market-monochrome');
  }

  @action
  addScrollBlock() {
    const element = document.scrollingElement as HTMLElement;
    if (element) {
      element.dataset.scrollBlock = 'true';
    }
  }

  @action
  removeScrollBlock() {
    const element = document.scrollingElement as HTMLElement;
    if (element) {
      delete element.dataset.scrollBlock;
    }
  }
}
